<template>
  <div class="tree">
    <div class="radish-act-grp">
      部门操作：
      <!-- <div class="radish-btn radish-btn-primary" @click="chooseShowDepartment">全选已显示</div> -->
      <div class="radish-btn radish-btn-primary" @click="clearCheckedDepartment">清空已勾选</div>
      <div class="radish-btn radish-btn-primary" @click="showDepartmentList(null)">打开已勾选部门人员</div>
    </div>
    <el-input
      placeholder="输入关键字进行搜索,搜索不影响已勾选部门"
      v-model="filterText"
      size="mini"
      @keyup.enter.native="toFilterText(filterText)"
    ></el-input>
    <el-tree
      class="flex-left-space overflow-auto"
      ref="tree"
      :data="tree"
      :props="defaultProps"
      node-key="_id"
      show-checkbox
      :expand-on-click-node="false"
      :default-expanded-keys="defaultExpandedKeys"
      :filter-node-method="filterNode"
    >
      <span slot-scope="{ node, data }">
        <span
          @dblclick="showDepartmentList(data)"
          onselectstart="return false;"
          style="margin-right:5px;color:#409eff;"
        >
          {{ data.部门 }}（{{ data.count }}）
        </span>
      </span>
    </el-tree>
  </div>
</template>
<script>
export default {
  props: {
    departments: { type: Array, default: () => [] },
    departmentName: { type: String, default: '' },
    companyNode: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      tree: [],
      copyTree: [],
      filterText: '',
      defaultExpandedKeys: [],
      defaultProps: {
        children: 'children',
        label: '名称',
      },
      checkedDepartments: [],
    }
  },
  watch: {
    tree(newValue, oldValue) {
      if (newValue.length !== 0) this.defaultExpandedKeys = [newValue[0]._id]
    },
    departments(newValue, oldValue) {
      if (newValue) this.toTreeData(newValue)
    },
  },
  async mounted() {
    await this.sleep(500)
  },
  methods: {
    toTreeData() {
      const parentnNode = JSON.parse(JSON.stringify(this.companyNode))
      parentnNode.children = this.departments

      this.tree = [parentnNode]
      this.copyTree = JSON.parse(JSON.stringify(this.tree))
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    chooseShowDepartment() {
      const { filterText, nodes } = this
      const hasCheckedDepartments = this.$refs.tree.getCheckedNodes()
      const checkedDepartments = (nodes || []).filter(v => v.部门.includes(filterText))
      checkedDepartments.forEach(v => {
        const flag = hasCheckedDepartments.find(val => val._id == v._id)
        if (!flag) hasCheckedDepartments.push(v)
      })
      this.$refs.tree.setCheckedNodes(hasCheckedDepartments)
    },
    clearCheckedDepartment() {
      this.checkedDepartments = []
      this.$refs.tree.setCheckedKeys([])
    },
    toFilterText(val) {
      this.$refs.tree.filter(val)
    },
    filterNode(value, data) {
      if (!value) return true
      const name = data.部门 || data.名称
      return name && name.includes(value)
    },
    showDepartmentList(nodeData) {
      const hasCheckedDepartments = this.$refs.tree.getCheckedNodes()
      this.$emit('showDepartmentList', nodeData || hasCheckedDepartments)
    },
  },
}
</script>
<style src="../../statistics/css/companyOchart.css" scoped></style>
